var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoResultPeople(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 91,
    viewBox: "0 0 92 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.9989 80.9978C63.0897 80.9978 80.9978 63.0897 80.9978 40.9989C80.9978 18.9081 63.0897 1 40.9989 1C18.9081 1 1 18.9081 1 40.9989C1 63.0897 18.9081 80.9978 40.9989 80.9978Z",
    stroke: "#2884FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M91 90L70 70",
    stroke: "#2884FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0902 56.9997V53.3329C50.0902 51.388 49.324 49.5226 47.9601 48.1473C46.5962 46.772 44.7464 45.9994 42.8176 45.9994H28.2725C26.3437 45.9994 24.4939 46.772 23.1301 48.1473C21.7662 49.5226 21 51.388 21 53.3329V56.9997",
    stroke: "#2884FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.546 38.6671C39.5625 38.6671 42.8185 35.3838 42.8185 31.3335C42.8185 27.2833 39.5625 24 35.546 24C31.5295 24 28.2734 27.2833 28.2734 31.3335C28.2734 35.3838 31.5295 38.6671 35.546 38.6671Z",
    stroke: "#2884FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9993 56.9987V53.3319C60.9981 51.707 60.4618 50.1286 59.4746 48.8444C58.4873 47.5602 57.1051 46.6429 55.5449 46.2367",
    stroke: "#2884FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2734 24.2383C49.8378 24.6422 51.2243 25.5596 52.2145 26.846C53.2047 28.1323 53.7421 29.7143 53.7421 31.3427C53.7421 32.971 53.2047 34.5531 52.2145 35.8394C51.2243 37.1257 49.8378 38.0432 48.2734 38.4471",
    stroke: "#2884FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoResultPeople);
export default __webpack_public_path__ + "static/media/no-result-people.2cb85c012c34217515832674c17126a4.svg";
export { ForwardRef as ReactComponent };